export default __webpack_public_path__ + "static/assets/723302d314c4ed6c44590aca28fdcff8.jpg";